export default __webpack_public_path__ + "static/media/mani.6424ab85.png";